import { render, staticRenderFns } from "./JiShiAddClock.vue?vue&type=template&id=0c8beaf8&scoped=true"
import script from "./JiShiAddClock.vue?vue&type=script&lang=js"
export * from "./JiShiAddClock.vue?vue&type=script&lang=js"
import style0 from "./JiShiAddClock.vue?vue&type=style&index=0&id=0c8beaf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8beaf8",
  null
  
)

export default component.exports